const centerModal = ({ onClosed }) =>
  window.asos.siteChrome.modals.openDivModal({
    modalType: window.asos.siteChrome.modals.modalTypes.CENTER,
    onClosed
  });

export default centerModal;
